import React, { PureComponent } from 'react'
import {
  Form,
  Input,
  Select,
  Button,
  Icon, Col, Row, Tooltip, Drawer, notification, Card, Checkbox
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import { hideLoader, hidePageLoad } from '../../../modules/actions'
import { connect } from 'react-redux'
import { listAllUniversities } from '../../university/actions/university'
import { listAllCountries } from '../../countries/actions/countries'
import {
  InputBox,
  departmentObj
} from '../../../components/_utils/appUtils'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import {
  listAllUsers, addEmployee
} from '../actions/user'
import { CountryCodeWithFlag, LoadAllCountry } from '../../../components/_utils/countryUtil'

let users = [
  {
    name: 'Admin',
    value: 'admin'
  },
  {
    name: 'Branch Manager',
    value: 'branchManager'
  },
  {
    name: 'Branch User',
    value: 'branchUser'
  },
  {
    name: 'Agent',
    value: 'agent'
  }
]


const FormItem = Form.Item
const { Option } = Select
const { TextArea } = Input

@Form.create()
class AddEmployee extends PureComponent {

  events = {
    selectAllUni: () => {
      const { form: { setFieldsValue } } = this.props
      let { universityList } = this.state
      let universities = []
      _.each(universityList, (item) => {
        if (item && item._id) {
          universities.push(item._id)
        }
      })
      setFieldsValue({
        universities: universities
      })
    },
    deSelectAllUni: () => {
      const { form: { setFieldsValue } } = this.props
      let universities = []
      setFieldsValue({
        universities: universities
      })
    },

    assignUserFnx: (id) => {
      let user = _.find(this.state.usersForAgent, (item) => {
        return item._id === id
      })
      this.setState({
        createdByUserIdName: user.name,
        createdByUser: {
          name: user.name,
          userId: user._id,
          time: new Date()
        }
      })
    },
    assignAgentUser: (id) => {
      let user = _.find(this.state.usersForAgent, (item) => {
        return item._id === id
      })
      this.setState({
        createdByUserIdName: user.name,
        createdByUser: {
          name: user.name,
          userId: user._id,
          time: new Date()
        }
      })
    }
  }

  agentEvents = {
    fetchAgent: async (name) => {
      let { dispatch } = this.props
      let obj = {
        results: 100,
        userType: 'agent',
        sortField: 'name',
        sortOrder: 'ascend',
        select: ['name', 'companyName'],
        name: name,
        block: false
      }
      let { data } = await dispatch(listAllUsers(obj))
      this.setState({
        agentList: data
      })
    }
    // removeAgent: (index) => {
    //   let cloneAgent = _.clone(this.state.agents)
    //   cloneAgent.splice(index, 1)
    //   this.setState({
    //     agents: cloneAgent
    //   })
    // },
    // chooseAgent: (data) => {
    //   let { agents, agentList } = this.state
    //   let findUser = _.find(agents, (item) => {
    //     return item._id && item._id.toString() == data
    //   })
    //   if (findUser) {
    //     this.setState({
    //       agentName: '',
    //       agentList: []
    //     })
    //     return notification.warning({
    //       message: 'Agent already exists.'
    //     })
    //   } else {
    //     let findAgent = _.find(agentList, (item) => {
    //       return item._id && item._id.toString() == data
    //     })
    //     if (findAgent) {
    //       let cloneAgents = _.clone(agents)
    //       cloneAgents.push(findAgent)
    //       this.setState({
    //         agentName: '',
    //         agentList: [],
    //         agents: cloneAgents
    //       })
    //     }
    //   }
    // }
  }
  conditionalFxn = {
    countryFieldFxn: () => {
      const {
        form: { getFieldValue }
      } = this.props
      return (getFieldValue('userType') && ((getFieldValue('userType') == 'branchUser' && (getFieldValue('department') !== departmentObj.visaApproved && getFieldValue('department') !== departmentObj.warningDepartment) && getFieldValue('department')) || getFieldValue('userType') == 'branchManager'))
    },
    branchManagerFieldFxn: () => {
      const {
        form: { getFieldValue }
      } = this.props
      return ((getFieldValue('userType') && getFieldValue('department')) && (getFieldValue('userType') == 'branchUser' && (getFieldValue('department') !== departmentObj.visaApproved && getFieldValue('department') !== departmentObj.warningDepartment)))
    },
    approvedAgentFieldFxn: () => {
      const {
        form: { getFieldValue }
      } = this.props
      return (getFieldValue('userType') && (getFieldValue('userType') == 'admin' || getFieldValue('userType') == 'branchManager' || getFieldValue('userType') == 'branchUser'))
    },
    universitySelectFieldFxn: () => {
      const {
        form: { getFieldValue }
      } = this.props
      return (getFieldValue('userType') &&
        ((getFieldValue('userType') == 'branchUser' && getFieldValue('department') && (getFieldValue('department').indexOf('Visa') < 0 && getFieldValue('department') !== departmentObj.warningDepartment)) || (getFieldValue('userType') == 'branchManager' && getFieldValue('branchManagerType') == 'universityWise'))
      )
    },
    universitySelectFieldFxnRequired: () => {
      const {
        form: { getFieldValue }
      } = this.props
      return (getFieldValue('userType') &&
        ((getFieldValue('userType') == 'branchUser' && getFieldValue('department') && (getFieldValue('department').indexOf('Visa') < 0 && getFieldValue('department') !== departmentObj.warningDepartment)) || (getFieldValue('userType') == 'branchManager' && getFieldValue('branchManagerType') == 'universityWise'))
      )
    }

  }

  constructor(props) {
    super(props)
    this.state = {
      allBranch: [],
      universityList: [],
      userList: [],
      linkedUser: [],
      countryList: [],
      mainBranchArr: [],
      logo: {},
      uploadKey: moment(),
      oldLogo: {},
      oldContract: {},
      oldPanCard: {},
      oldPassport: {},
      oldAadharCard: {},
      agentList: [],
      agents: [],
      userData: {},
      usersForAgent: [],
      marketingManagerForAgent: [],
      displayAgentUsers: [],
      displayAgentManagers: [],
      createdByUserIdName: '',
      createdByUser: {},
      allCountries: LoadAllCountry(),
      allStates: [],
      allCities: [],
      selectedMarketingUser: [],
      countryCode: '',
      departmentCountryId: ''
    }
  }

  componentDidMount() {

    this.loadCountry()
    this.loadUserData()
    this.loadUserForEmployee()
    let { dispatch } = this.props
    dispatch({ type: 'USER_HIDELOADER' })
    dispatch(hideLoader())
    dispatch(hidePageLoad())
  }

  async loadUserData() {
    let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
    this.setState({ userData: user })
  }

  async loadUserForEmployee() {
    let { dispatch } = this.props
    let obj = {
      userType: ['branchManager', 'branchUser'],
      /* customQuery: {
         'approvedAgent': true
       },*/
      results: 100,
      select: ['name', 'email']
    }
    let { data } = await dispatch(listAllUsers(obj))
    this.setState({ userList: data })
  }

  handleSubmit = e => {
    const { dispatch, form, onClose, reloadTable } = this.props
    let { getFieldValue } = form
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let {
          address,
          agents,
          logo,
          panCard,
          aadharCard,
          passport,
          contract,
          createdByUser,
          countryCode,
          departmentCountryId
        } = this.state
        if (!countryCode) {
          notification.error({
            message: 'Please choose County Code'
          })
          return
        }
        if (valData.assignAgentType == 'selected' || valData.assignAgentType == 'exceptSelected') {
          if ((agents && agents.length == 0) || !agents) {
            notification.error({
              message: 'Please choose Agents'
            })
            return
          }
        }
        if (createdByUser && createdByUser.userId) {
          valData.createdByUser = createdByUser
        }
        valData.address = address
        valData.countryISOCode = countryCode


        // valData.forex = selectedDepartment == 'Forex'
        // valData.gic = selectedDepartment == 'Gic'
        // valData.unizHome = selectedDepartment == 'UnizHome'
        // valData.xTravel = selectedDepartment == 'XTravel'
        // valData.international = selectedDepartment == 'International'
        // valData.other = selectedDepartment == 'Other'
        if (departmentCountryId) {
          valData.departmentCountryId = departmentCountryId
        }

        let fd = new FormData()


        fd.append('obj', JSON.stringify(valData))

        if (logo && logo.name) {
          fd.append('logo', logo)
        }

        if (panCard && panCard.name) {
          fd.append('panCard', panCard)
        }

        if (aadharCard && aadharCard.name) {
          fd.append('aadharCard', aadharCard)
        }

        if (contract && contract.name) {
          fd.append('contract', contract)
        }
        if (passport && passport.name) {
          fd.append('passport', passport)
        }

        let data = await dispatch(addEmployee(fd))
        if (data && !data.error) {
          this.setState({
            address: '',
            uploadKey: moment(),
            logo: {}
          })
          onClose()
          if (reloadTable) {
            reloadTable()
          }
        }
      }
    })
  }

  async loadCountry() {
    let { dispatch } = this.props
    let countryFilter = {
      results: 10,
      sortField: 'countryName',
      sortOrder: 'ascend',
      active: [true, false]
    }
    let { data } = await dispatch(listAllCountries(countryFilter))
    let otherData = [
      {
        _id: '',
        countryName: 'Forex'
      },
      {
        _id: '',
        countryName: 'Gic'
      },
      {
        _id: '',
        countryName: 'Unizhome'
      },
      {
        _id: '',
        countryName: 'Xtravel'
      },
      {
        _id: '',
        countryName: 'International'
      },
      {
        _id: '',
        countryName: 'Canada Private'
      },
      {
        _id: '',
        countryName: 'Other'
      }
    ]
    data.push(...otherData)
    this.setState({
      countryList: data
    })
  }


  async loadCountryUniversity(countryId) {
    let { dispatch } = this.props
    let { data } = await dispatch(listAllUniversities({
      results: 1000000, universityCountry: countryId,
      sortField: 'universityName',
      sortOrder: 'ascend'
    }))
    this.setState({
      universityList: data,
      name: '',
      userType: ''
    })
  }


  render() {

    const { submitting, dispatch, visible, onClose } = this.props
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue }
    } = this.props

    const {
      oldLogo,
      oldPanCard,
      oldPassport,
      oldAadharCard,
      oldContract,
      agentName,
      agentList,
      agents,
      userData
    } = this.state

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      }
    }

    const submitFormLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 10, offset: 7 },
        md: { span: 12, offset: 8 }
      }
    }
    let departmentArr = ['Forex', 'Gic', 'UnizHome', 'XTravel', 'International', 'Other']


    let inputTypes = {
      fields: [
        {
          label: 'Contact Person Name',
          key: 'name',
          required: true
        },
        {
          key: 'countryCode',
          span: 3,
          customField: (
            <div style={{ marginTop: 5 }}>
              <CountryCodeWithFlag countryCode={this.state.countryCode} chooseCode={(val) => {
                this.setState({
                  countryCode: val
                })
              }} />
            </div>
          )
        },
        {
          span: 5,
          label: 'Mobile no',
          key: 'mobile',
          type: 'number'
        },
        {
          label: 'Email',
          key: 'email'
        },
        {
          label: 'Designation',
          key: 'designation'
        },
        {
          label: 'Branch Manger',
          key: 'branchMangerId',
          hidden: !this.conditionalFxn.branchManagerFieldFxn(),
          type: 'select',
          valueAccessor: x => x.name,
          keyAccessor: x => x._id,
          options: this.state.mainBranchArr,
          onChange: v => {
            setFieldsValue({
              branchMangerId: v
            })
          }
        },

        {
          key: 'dateOfBirth',
          label: 'Date Of Birth',
          type: 'date'
          // onChange: x => {
          //   setFieldsValue({
          //     createdAt: x.target.value
          //   })
          // }
        },
        {
          key: 'createdAt',
          label: 'Joining Date',
          type: 'date'
          // onChange: x => {
          //   setFieldsValue({
          //     createdAt: x.target.value
          //   })
          // }
        },


        {
          key: 'pincode',
          label: 'Pincode'
        },
        {
          key: 'linkedUser',
          label: '',
          label1: 'Link Users',
          type: 'select',
          showSearch: true,
          options: this.state.userList,
          // hidden: !(getFieldValue('userType') && getFieldValue('userType') == 'branchUser' && getFieldValue('department') && getFieldValue('department').indexOf('Visa') < 0),
          mode: 'multiple',
          keyAccessor: x => x._id,
          valueAccessor: x => `${x.name}(${x.email})`,
          onChange: x => {
            setFieldsValue({
              linkedUser: x
            })
          }
        },
        {
          key: 'Profile Picture',
          customField: (
            <InputBox title={'Profile Picture'} className={'logoCls rowFlex'}>
              <Input type={'file'} className={'form-control'}
                     key={this.state.uploadKey} name={'logo'} id={'logo'}
                     onChange={(e) => {
                       this.setState({
                         logo: e.target.files && e.target.files.length ? e.target.files[0] : null
                       })
                     }} />
              {oldLogo && oldLogo.url ?
                <Tooltip title={oldLogo.name}> <a className={'linkBtn'} target={'_blank'} href={oldLogo.url}>
                  <Icon type={'eye'}></Icon>
                </a> </Tooltip> : ''}
            </InputBox>
          )
        },
        {
          key: 'Aadhar Card',
          customField: (
            <InputBox title={'Adhar Card'} className={'logoCls rowFlex'}>
              <Input type={'file'} className={'form-control'}
                     key={this.state.uploadKey} name={'aadharCard'} id={'aadharCard'}
                     onChange={(e) => {
                       this.setState({
                         aadharCard: e.target.files && e.target.files.length ? e.target.files[0] : null
                       })
                     }} />
              {oldAadharCard && oldAadharCard.url ?
                <Tooltip title={oldAadharCard.name}> <a className={'linkBtn'} target={'_blank'}
                                                        href={oldAadharCard.url}>
                  <Icon type={'eye'}></Icon>
                </a> </Tooltip> : ''}
            </InputBox>
          )
        },
        {
          key: 'Pan Card',
          customField: (
            <InputBox title={'Pan Card'} className={'logoCls rowFlex'}>
              <Input type={'file'} className={'form-control'}
                     key={this.state.uploadKey} name={'panCard'} id={'panCard'}
                     onChange={(e) => {
                       this.setState({
                         panCard: e.target.files && e.target.files.length ? e.target.files[0] : null
                       })
                     }} />
              {oldPanCard && oldPanCard.url ?
                <Tooltip title={oldPanCard.name}> <a className={'linkBtn'} target={'_blank'} href={oldPanCard.url}>
                  <Icon type={'eye'}></Icon>
                </a> </Tooltip> : ''}
            </InputBox>
          )
        },
        {
          key: 'Passport',
          customField: (
            <InputBox title={'Passport'} className={'logoCls rowFlex'}>
              <Input type={'file'} className={'form-control'}
                     key={this.state.uploadKey} name={'passport'} id={'passport'}
                     onChange={(e) => {
                       this.setState({
                         passport: e.target.files && e.target.files.length ? e.target.files[0] : null
                       })
                     }} />
              {oldPassport && oldPassport.url ?
                <Tooltip title={oldPassport.name}> <a className={'linkBtn'} target={'_blank'} href={oldPassport.url}>
                  <Icon type={'eye'}></Icon>
                </a> </Tooltip> : ''}
            </InputBox>
          )
        },
        {
          key: 'Contract',
          customField: (
            <InputBox title={'Contract'} className={'logoCls rowFlex'}>
              <Input type={'file'} className={'form-control'}
                     key={this.state.uploadKey} name={'contract'} id={'contract'}
                     onChange={(e) => {
                       this.setState({
                         contract: e.target.files && e.target.files.length ? e.target.files[0] : null
                       })
                     }} />
              {oldContract && oldContract.url ?
                <Tooltip title={oldContract.name}> <a className={'linkBtn'} target={'_blank'} href={oldContract.url}>
                  <Icon type={'eye'}></Icon>
                </a> </Tooltip> : ''}
            </InputBox>
          )
        },

        {
          key: 'alternateMobileNo',
          label: (
            <span>
              Staff Member Mobile No <small style={{ color: 'black', fontWeight: 'bold' }}>( Note : Use comma for multiple mobiles no )</small>
            </span>
          ),
          placeholder: 'Staff Member Mobile No',
          span: 24,
          hidden: !(getFieldValue('userType') && getFieldValue('userType') == 'agent')
        },
        {
          key: 'departmentName',
          label: '',
          label1: 'Countries',
          type: 'select',
          showSearch: true,
          options: this.state.countryList,
          // mode: 'multiple',
          keyAccessor: x => x.countryName,
          valueAccessor: x => x.countryName,
          onChange: x => {
            setFieldsValue({
              departmentName: x
            })

            let countryData = this.state.countryList.find(country => country.countryName == x)
            if (countryData) {
              this.setState({
                departmentCountryId: countryData._id
              })
            }
          }
        },
        /* {
           key: 'CheckBoxes',
           span: 24,
           customField: (
             <InputBox title={'Department'} className={'logoCls rowFlex'}>
               <div className={'form-control'} style={{ backgroundColor: '#f1f1f1' }}>
                 {departmentArr.map((department) => (
                   <Checkbox
                     key={department}
                     checked={this.state.selectedDepartment === department}  // Check if this department is selected
                     onChange={(e) => {
                       // If this checkbox is checked, set the selectedDepartment to this department, otherwise null
                       this.setState({ selectedDepartment: e.target.checked ? department : null })
                       setFieldsValue({
                         departmentCountry: ''
                       })
                     }}
                   >
                     {department}
                   </Checkbox>
                 ))}
               </div>
             </InputBox>
           )
         },*/
        {
          key: 'address',
          span: 24,
          customField: (
            <InputBox title={'Address'}>
              <TextArea rows={4} className={'form-control'} value={this.state.address} onChange={(e) => {
                this.setState({ address: e.target.value })
              }}>
              </TextArea>
            </InputBox>
          )
        }

      ]
    }


    return (
      <Drawer
        title={`Add Employee`}
        visible={visible}
        placement='right'
        closable={true}
        onClose={onClose}
        width={'80%'}>
        <div className='form-box'>
          <div className='card unizportal'>
            <Form onSubmit={this.handleSubmit}>
              <Row gutter={16} className={'wrapBox'}>
                {inputTypes.fields.map((item, key) => {
                  return (
                    <React.Fragment key={key}>
                      {item.customField ? !item.hidden && <Col span={item.span ? item.span : 8}>
                        {item.customField}
                      </Col> : !item.hidden &&
                        <Col span={item.span ? item.span : 8} key={key}
                             style={item.extraBox1 ? { paddingBottom: 1 } : {}}>
                          <InputBox title={item.label1 ? item.label1 : ''} extra={item.extraBox1}>
                            <GetEachFormFields
                              item={item}
                              getFieldDecorator={getFieldDecorator}
                              formItemLayout={formItemLayout} />
                          </InputBox>
                        </Col>}
                    </React.Fragment>
                  )
                })}

                <Col span={24}>

                </Col>

                {/*{agents && agents.length ? <Col span={24}>*/}
                {/*  <Card title={'Agents'} size={'small'}>*/}
                {/*    <div className={'guestEmailBox'}>*/}
                {/*      <ul>*/}
                {/*        {agents.map((item, index) => {*/}
                {/*          return (*/}
                {/*            <li className={'emailTag'} key={index}>*/}
                {/*              {item.name} ({item.companyName})*/}
                {/*              <Icon type={'close'}*/}
                {/*                    onClick={() => this.agentEvents.removeAgent(index)}*/}
                {/*                    className={'emailIcon'} />*/}
                {/*            </li>*/}
                {/*          )*/}
                {/*        })}*/}
                {/*      </ul>*/}
                {/*    </div>*/}
                {/*  </Card>*/}
                {/*</Col> : null}*/}
              </Row>


              <Form.Item>
                <Button type='primary' htmlType='submit' loading={this.props.loading} className={'btn'}>
                  SAVE
                </Button>
              </Form.Item>

            </Form>
          </div>
        </div>

      </Drawer>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  pathname: router.location.pathname,
  search: router.location.search
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEmployee)
